import { Component, Input, OnInit } from "@angular/core";
import { DashboardVisitorService } from "../dashboard-visitor.service";
import * as moment from "moment";

@Component({
	selector: "caass-visitor-graph",
	templateUrl: "./visitor-graph.component.html",
	styleUrls: ["./visitor-graph.component.css"],
})
export class VisitorGraphComponent implements OnInit {
	constructor(private dashboardService: DashboardVisitorService) {}

	ngOnInit(): void {
		this.basicOptions = {
			plugins: {
				legend: {
					labels: {
						color: "#495057",
					},
				},
			},
			scales: {
				x: {
					ticks: {
						color: "#495057",
					},
					grid: {
						color: "#ebedef",
					},
				},
				y: {
					ticks: {
						color: "#495057",
					},
					grid: {
						color: "#ebedef",
					},
				},
			},
		};

		this.basicData = {
			labels: ["January", "February", "March", "April", "May", "June", "July"],
			datasets: [
				{
					label: "My First dataset",
					backgroundColor: "#42A5F5",
					data: [65, 59, 80, 81, 56, 55, 40],
				},
				{
					label: "My Second dataset",
					backgroundColor: "#FFA726",
					data: [28, 48, 40, 19, 86, 27, 90],
				},
			],
		};

		this.InitBasicOptions();

		this.loadOptionList();
		// this.loadData();
	}

	ngOnChanges() {
		this.UpdateGraph();
	}

	/////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////

	@Input() FacilityID: any;
	@Input() GraphPanel: number;

	Inited: boolean = false;

	LoadingOption: boolean = false;
	Option: any;
	lstOption: any = [];

	LoadingData: boolean = false;
	lstData: any = [];

	ShowGraph: boolean = false;
	basicData: any;
	basicOptions: any;

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////

	loadOptionList() {
		this.LoadingOption = true;

		var result = this.dashboardService.VisitorGraphOptionSelectList();
		result.subscribe(
			(response) => {
				this.lstOption = response;

				if (this.lstOption.length > 0) {
					for (var z = 0; z < this.lstOption.length; z++) {
						var next = this.lstOption[z];

						if (next.Selected == true) {
							this.Option = next;
							break;
						}
					}

					if (this.Option == undefined) {
						this.Option = this.lstOption[0];
					}

					if (this.GraphPanel != undefined) {
						for (var z = 0; z < this.lstOption.length; z++) {
							var next = this.lstOption[z];

							if (next.ID == this.GraphPanel) {
								this.Option = next;
							}
						}
					}
				}

				this.LoadingOption = false;

				this.loadData();
			},
			(error) => {
				this.LoadingOption = false;
			}
		);
	}

	loadData() {
		this.LoadingData = true;

		var result = this.dashboardService.VisitorGraphInfoSelectList();
		result.subscribe(
			(response) => {
				this.lstData = response;

				this.Inited = true;

				this.UpdateGraph();

				this.LoadingData = false;
			},
			(error) => {
				this.LoadingData = false;
			}
		);
	}

	UpdateGraph() {
		this.ShowGraph = false;

		if (this.Inited == false) {
			return;
		}

		if (this.Option == undefined) {
			return;
		} else if (this.Option.ID == undefined || this.Option.ID <= 0) {
			return;
		}

		if (this.Option.ID == 1) {
			this.FacilityYTD();
		}
		if (this.Option.ID == 2) {
			this.FacilityMTD();
		}
		if (this.Option.ID == 3) {
			this.FacilityWTD();
		}
		if (this.Option.ID == 4) {
			this.Facility24H();
		}
		if (this.Option.ID == 5) {
			this.Facility12H();
		}
		if (this.Option.ID == 6) {
			this.DistrictYTD();
		}
		if (this.Option.ID == 7) {
			this.DistrictMTD();
		}
		if (this.Option.ID == 8) {
			this.DistrictWTD();
		}
		if (this.Option.ID == 9) {
			this.District24H();
		}
		if (this.Option.ID == 10) {
			this.District12H();
		}
	}

	FacilityYTD() {
		var labels: string[] = [];
		var myData: number[] = [];

		var AllMonths: any = [
			{ JsMonthInt: 7, Desc: "August" },
			{ JsMonthInt: 8, Desc: "September" },
			{ JsMonthInt: 9, Desc: "October" },
			{ JsMonthInt: 10, Desc: "November" },
			{ JsMonthInt: 11, Desc: "December" },
			{ JsMonthInt: 0, Desc: "January" },
			{ JsMonthInt: 1, Desc: "February" },
			{ JsMonthInt: 2, Desc: "March" },
			{ JsMonthInt: 3, Desc: "April" },
			{ JsMonthInt: 4, Desc: "May" },
			{ JsMonthInt: 5, Desc: "June" },
			{ JsMonthInt: 6, Desc: "July" },
		];

		var CurrentMonthInt: number = new Date().getMonth();

		for (var z = 0; z < AllMonths.length; z++) {
			var next = AllMonths[z];

			labels = [...labels, next.Desc];
			myData = [...myData, 0]; //Init to 0

			if (Number(next.JsMonthInt) == Number(CurrentMonthInt)) {
				break;
			}
		}

		//Get data only for the selected facility
		var facilityData: any = [];
		facilityData = this.lstData.filter((v) => v.FacilityID == this.FacilityID);

		for (var z = 0; z < facilityData.length; z++) {
			var next = facilityData[z];

			var nextMonthInt = new Date(next.LogDT).getMonth();
			var arrInt = this.GetArrayIntFromMonth(nextMonthInt);

			myData[arrInt] = myData[arrInt] + 1;
		}

		//
		// Update Basic Data
		//
		this.basicData = {
			labels: labels,
			datasets: [
				{
					label: "Visitors",
					backgroundColor: "#42A5F5",
					data: myData,
				},
			],
		};

		this.ShowGraph = true;
	}

	FacilityMTD() {
		//
		//  Labels
		//
		var labels: string[] = [];
		var CurrentDayInt: number = new Date().getDate();

		var myData: number[] = [];

		for (var z = 0; z < CurrentDayInt; z++) {
			labels = [...labels, (z + 1).toString()];
			myData = [...myData, 0]; //Init to 0
		}

		//
		// Data
		//

		//Get data only for this month
		var monthData: any = [];
		monthData = this.lstData.filter((v) => v.InMonth == true);
		monthData = monthData.filter((v) => v.FacilityID == this.FacilityID);

		for (var z = 0; z < monthData.length; z++) {
			var next = monthData[z];

			var nextDayInt = new Date(next.LogDT).getDate() - 1;

			myData[nextDayInt] = myData[nextDayInt] + 1;
		}

		//
		// Update Basic Data
		//
		this.basicData = {
			labels: labels,
			datasets: [
				{
					label: "Visitors",
					backgroundColor: "#42A5F5",
					data: myData,
				},
			],
		};

		this.ShowGraph = true;
	}

	FacilityWTD() {
		//
		//  Labels
		//
		var labels: string[] = [];
		var AllDayNames: string[] = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
		var CurrentDayInt: number = new Date().getDay(); //Sun 0, Sat 6

		var myData: number[] = [];

		if (CurrentDayInt == 0) {
			labels = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
			myData = [0, 0, 0, 0, 0, 0, 0]; //Init to 0
		} else {
			for (var z = 1; z <= CurrentDayInt; z++) {
				labels = [...labels, AllDayNames[z]];
				myData = [...myData, 0]; //Init to 0
			}
		}

		//
		// Data
		//

		//Get data only for this month
		var weekData: any = [];
		weekData = this.lstData.filter((v) => v.InWeek == true);
		weekData = weekData.filter((v) => v.FacilityID == this.FacilityID);

		for (var z = 0; z < weekData.length; z++) {
			var next = weekData[z];

			var nextDayInt = new Date(next.LogDT).getDay() - 1; //Start on Monday

			//Sunday -> -1, set to last item in list
			if (nextDayInt < 0) {
				nextDayInt = 6;
			}

			myData[nextDayInt] = myData[nextDayInt] + 1;
		}

		//
		// Update Basic Data
		//
		this.basicData = {
			labels: labels,
			datasets: [
				{
					label: "Visitors",
					backgroundColor: "#42A5F5",
					data: myData,
				},
			],
		};

		this.ShowGraph = true;
	}

	Facility24H() {
		//
		//  Labels
		//
		var labels: string[] = [];
		var myData: number[] = [];
		var dates: Date[] = [];

		var StartDate: Date = new Date();
		var EndDate: Date = new Date();
		var CurrentDate: Date = new Date();

		StartDate.setHours(StartDate.getHours() - 24);
		CurrentDate = new Date(StartDate);

		while (CurrentDate <= EndDate) {
			var nextDate = new Date(CurrentDate);

			labels = [...labels, moment(nextDate).format("h:00 a")];

			dates = [...dates, new Date(moment(nextDate).format("MM/DD/YYYY HH:00:00"))];

			CurrentDate.setHours(CurrentDate.getHours() + 1);
			myData = [...myData, 0];
		}

		//
		// Data
		//

		//Get data only for this month
		var hourlyData: any = [];
		hourlyData = this.lstData.filter((v) => v.In24 == true);
		hourlyData = hourlyData.filter((v) => v.FacilityID == this.FacilityID);

		for (var z = 0; z < hourlyData.length; z++) {
			var next = hourlyData[z];
			var nextDate = new Date(next.LogDT);

			for (var x = 0; x < dates.length - 1; x++) {
				var firstDate: Date = dates[x];
				var secondDate: Date = dates[x + 1];

				if (nextDate >= firstDate && nextDate <= secondDate) {
					myData[x] = myData[x] + 1;
					break;
				} else if (x == dates.length - 1) {
					myData[x + 1] = myData[x + 1] + 1;
					break;
				}
			}
		}

		//
		// Update Basic Data
		//
		this.basicData = {
			labels: labels,
			datasets: [
				{
					label: "Visitors",
					backgroundColor: "#42A5F5",
					data: myData,
				},
			],
		};

		this.ShowGraph = true;
	}

	Facility12H() {
		//
		//  Labels
		//
		var labels: string[] = [];
		var myData: number[] = [];
		var dates: Date[] = [];

		var StartDate: Date = new Date();
		var EndDate: Date = new Date();
		var CurrentDate: Date = new Date();

		StartDate.setHours(StartDate.getHours() - 12);
		CurrentDate = new Date(StartDate);

		while (CurrentDate <= EndDate) {
			var nextDate = new Date(CurrentDate);

			labels = [...labels, moment(nextDate).format("h:00 a")];

			dates = [...dates, new Date(moment(nextDate).format("MM/DD/YYYY HH:00:00"))];

			CurrentDate.setHours(CurrentDate.getHours() + 1);
			myData = [...myData, 0];
		}

		//
		// Data
		//

		//Get data only for this month
		var hourlyData: any = [];
		hourlyData = this.lstData.filter((v) => v.In12 == true);
		hourlyData = hourlyData.filter((v) => v.FacilityID == this.FacilityID);

		for (var z = 0; z < hourlyData.length; z++) {
			var next = hourlyData[z];
			var nextDate = new Date(next.LogDT);

			for (var x = 0; x < dates.length - 1; x++) {
				var firstDate: Date = dates[x];
				var secondDate: Date = dates[x + 1];

				if (nextDate >= firstDate && nextDate <= secondDate) {
					myData[x] = myData[x] + 1;
					break;
				} else if (x == dates.length - 1) {
					myData[x + 1] = myData[x + 1] + 1;
					break;
				}
			}
		}

		//
		// Update Basic Data
		//
		this.basicData = {
			labels: labels,
			datasets: [
				{
					label: "Visitors",
					backgroundColor: "#42A5F5",
					data: myData,
				},
			],
		};

		this.ShowGraph = true;
	}

	DistrictYTD() {
		var labels: string[] = [];
		var myData: number[] = [];

		var AllMonths: any = [
			{ JsMonthInt: 7, Desc: "August" },
			{ JsMonthInt: 8, Desc: "September" },
			{ JsMonthInt: 9, Desc: "October" },
			{ JsMonthInt: 10, Desc: "November" },
			{ JsMonthInt: 11, Desc: "December" },
			{ JsMonthInt: 0, Desc: "January" },
			{ JsMonthInt: 1, Desc: "February" },
			{ JsMonthInt: 2, Desc: "March" },
			{ JsMonthInt: 3, Desc: "April" },
			{ JsMonthInt: 4, Desc: "May" },
			{ JsMonthInt: 5, Desc: "June" },
			{ JsMonthInt: 6, Desc: "July" },
		];

		var CurrentMonthInt: number = new Date().getMonth();

		for (var z = 0; z < AllMonths.length; z++) {
			var next = AllMonths[z];

			labels = [...labels, next.Desc];
			myData = [...myData, 0]; //Init to 0

			if (Number(next.JsMonthInt) == Number(CurrentMonthInt)) {
				break;
			}
		}

		//
		// Data
		//
		for (var z = 0; z < this.lstData.length; z++) {
			var next = this.lstData[z];

			var nextMonthInt = new Date(next.LogDT).getMonth();
			var arrInt = this.GetArrayIntFromMonth(nextMonthInt);

			myData[arrInt] = myData[arrInt] + 1;
		}

		//
		// Update Basic Data
		//
		this.basicData = {
			labels: labels,
			datasets: [
				{
					label: "Visitors",
					backgroundColor: "#42A5F5",
					data: myData,
				},
			],
		};

		this.ShowGraph = true;
	}

	DistrictMTD() {
		//
		//  Labels
		//
		var labels: string[] = [];
		var CurrentDayInt: number = new Date().getDate();

		var myData: number[] = [];

		for (var z = 0; z < CurrentDayInt; z++) {
			labels = [...labels, (z + 1).toString()];
			myData = [...myData, 0]; //Init to 0
		}

		//
		// Data
		//

		//Get data only for this month
		var monthData: any = [];
		monthData = this.lstData.filter((v) => v.InMonth == true);

		for (var z = 0; z < monthData.length; z++) {
			var next = monthData[z];

			var nextDayInt = new Date(next.LogDT).getDate() - 1;

			myData[nextDayInt] = myData[nextDayInt] + 1;
		}

		//
		// Update Basic Data
		//
		this.basicData = {
			labels: labels,
			datasets: [
				{
					label: "Visitors",
					backgroundColor: "#42A5F5",
					data: myData,
				},
			],
		};

		this.ShowGraph = true;
	}

	DistrictWTD() {
		//
		//  Labels
		//
		var labels: string[] = [];
		var AllDayNames: string[] = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
		var CurrentDayInt: number = new Date().getDay(); //Sun 0, Sat 6

		var myData: number[] = [];

		if (CurrentDayInt == 0) {
			labels = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
			myData = [0, 0, 0, 0, 0, 0, 0]; //Init to 0
		} else {
			for (var z = 1; z <= CurrentDayInt; z++) {
				labels = [...labels, AllDayNames[z]];
				myData = [...myData, 0]; //Init to 0
			}
		}

		//
		// Data
		//

		//Get data only for this month
		var weekData: any = [];
		weekData = this.lstData.filter((v) => v.InWeek == true);

		for (var z = 0; z < weekData.length; z++) {
			var next = weekData[z];

			var nextDayInt = new Date(next.LogDT).getDay() - 1; //Start on Monday

			//Sunday -> -1, set to last item in list
			if (nextDayInt < 0) {
				nextDayInt = 6;
			}

			myData[nextDayInt] = myData[nextDayInt] + 1;
		}

		//
		// Update Basic Data
		//
		this.basicData = {
			labels: labels,
			datasets: [
				{
					label: "Visitors",
					backgroundColor: "#42A5F5",
					data: myData,
				},
			],
		};

		this.ShowGraph = true;
	}

	District24H() {
		//
		//  Labels
		//
		var labels: string[] = [];
		var myData: number[] = [];
		var dates: Date[] = [];

		var StartDate: Date = new Date();
		var EndDate: Date = new Date();
		var CurrentDate: Date = new Date();

		StartDate.setHours(StartDate.getHours() - 24);
		CurrentDate = new Date(StartDate);

		while (CurrentDate <= EndDate) {
			var nextDate = new Date(CurrentDate);

			labels = [...labels, moment(nextDate).format("h:00 a")];

			dates = [...dates, new Date(moment(nextDate).format("MM/DD/YYYY HH:00:00"))];

			CurrentDate.setHours(CurrentDate.getHours() + 1);
			myData = [...myData, 0];
		}

		//
		// Data
		//

		//Get data only for this month
		var hourlyData: any = [];
		hourlyData = this.lstData.filter((v) => v.In24 == true);

		for (var z = 0; z < hourlyData.length; z++) {
			var next = hourlyData[z];
			var nextDate = new Date(next.LogDT);

			for (var x = 0; x < dates.length - 1; x++) {
				var firstDate: Date = dates[x];
				var secondDate: Date = dates[x + 1];

				if (nextDate >= firstDate && nextDate <= secondDate) {
					myData[x] = myData[x] + 1;
					break;
				} else if (x == dates.length - 1) {
					myData[x + 1] = myData[x + 1] + 1;
					break;
				}
			}
		}

		//
		// Update Basic Data
		//
		this.basicData = {
			labels: labels,
			datasets: [
				{
					label: "Visitors",
					backgroundColor: "#42A5F5",
					data: myData,
				},
			],
		};

		this.ShowGraph = true;
	}

	District12H() {
		//
		//  Labels
		//
		var labels: string[] = [];
		var myData: number[] = [];
		var dates: Date[] = [];

		var StartDate: Date = new Date();
		var EndDate: Date = new Date();
		var CurrentDate: Date = new Date();

		StartDate.setHours(StartDate.getHours() - 12);
		CurrentDate = new Date(StartDate);

		while (CurrentDate <= EndDate) {
			var nextDate = new Date(CurrentDate);

			labels = [...labels, moment(nextDate).format("h:00 a")];

			dates = [...dates, new Date(moment(nextDate).format("MM/DD/YYYY HH:00:00"))];

			CurrentDate.setHours(CurrentDate.getHours() + 1);
			myData = [...myData, 0];
		}

		//
		// Data
		//

		//Get data only for this month
		var hourlyData: any = [];
		hourlyData = this.lstData.filter((v) => v.In12 == true);

		for (var z = 0; z < hourlyData.length; z++) {
			var next = hourlyData[z];
			var nextDate = new Date(next.LogDT);

			for (var x = 0; x < dates.length - 1; x++) {
				var firstDate: Date = dates[x];
				var secondDate: Date = dates[x + 1];

				if (nextDate >= firstDate && nextDate <= secondDate) {
					myData[x] = myData[x] + 1;
					break;
				} else if (x == dates.length - 1) {
					myData[x + 1] = myData[x + 1] + 1;
					break;
				}
			}
		}

		//
		// Update Basic Data
		//
		this.basicData = {
			labels: labels,
			datasets: [
				{
					label: "Visitors",
					backgroundColor: "#42A5F5",
					data: myData,
				},
			],
		};

		this.ShowGraph = true;
	}

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////////
	onOptionChange(val) {
		this.Option = val;

		this.UpdateGraph();
	}
	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingOption == true || this.LoadingData == true;
	}

	InitBasicOptions() {
		this.basicOptions = {
			plugins: {
				legend: {
					labels: {
						color: "#495057",
					},
				},
			},
			scales: {
				x: {
					ticks: {
						color: "#495057",
					},
					grid: {
						color: "#ebedef",
					},
				},
				y: {
					ticks: {
						color: "#495057",
					},
					grid: {
						color: "#ebedef",
					},
				},
			},
		};
	}

	GetArrayIntFromMonth(monthInt: number) {
		var x = 0;

		if (monthInt >= 7) {
			x = (monthInt - 7) % 12;
		} else {
			x = monthInt + (5 % 12);
		}

		return x;
	}

	/////////////////////////////////////////////////////////////////////
}
